export enum ProductsTabs {
  FEATURED = 'featured',
  LOCAL = 'local',
  GLOBAL = 'global',
  PREPAID = 'prepaid',
  ALL = 'all',
}
